import {
  AllergenEnum,
  DayOfWeek,
  DishDto,
  FluiditeTauxOccupationValues,
  FormulaDto,
  GetCurrentFluiditeResult,
  GetExternalRestaurantHomeResult,
  GetFluiditeRatesResult,
  GetRestaurantMenusResult,
  GetRestaurantsResult,
  NavbarPosition,
  NutritionnalValueTypeEnum,
  NutritionnalValueUnitEnum,
  RestaurantServiceValues,
  RestaurantSousTypeValues,
  RestaurantTypeValues,
} from '@timechef/core/api';
import { addMinutes } from 'date-fns';
import { Response } from 'miragejs';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse, getSuccessEmptyResponse } from './common';
import { BIG_DESCRIPTION } from './mock-base64';

export const MOCK_SCORP_RESTAURANT_ID = 12;
export const MOCK_SCORP_ANTI_GASPI_RESTAURANT_ID = 13;

export const getTodayWithHour = (hour: number, min: number) => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, min, 0).toISOString();
};

const getDayFromTodayWithHour = (daysAfter: number, hour: number, min: number) => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysAfter, hour, min, 0).toISOString();
};

const weekDays = [DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday];

export const MOCK_UPDATE_DISH_LIKES: { OK: Response; KO: Response } = {
  OK: getSuccessEmptyResponse(),
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

const MOCK_GET_RESTAURANTS_MULTI_OK: GetRestaurantsResult = {
  restaurants: [
    {
      id: 1,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: true,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept1.png',
      title: 'Wonderfood',
      surveyCampaign: {
        alreadyAnsweredToday: false,
        campaignId: 1,
        restaurantId: 1,
        surveyId: 1,
      },
      type: RestaurantTypeValues.DinnerTakeaway,
      description:
        '<p class="xmsonormal" style="margin: 0cm 0cm 12.0pt 0cm;"><span style="font-size: 11.0pt; font-family: \'Calibri\',sans-serif; color: #201f1e;">Peu de temps pour d&eacute;jeuner&nbsp;? Envie de d&eacute;jeuner au bureau&nbsp;?</span></p>',
      typeLabel: 'Click & Collect',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 2,
      animation: {
        startsAt: new Date(2022, 4, 1).toISOString(),
        endsAt: new Date(2022, 4, 1).toISOString(),
        id: 0,
        title: 'Semaine Américaine, le Wonderfood',
        backgroundColor: '#ffb146',
        fontColor: '#000000',
        description: 'Un ensemble de spécialités américaines vous sera proposé au sein de votre restaurant. Vous pourrez les déguster sous forme de buffet.',
        shortDescription: 'Retrouvons-nous pour voyager en Amérique et profiter de sa cuisine.',
        imageUrl: '../../../../assets-proxy/animations/animation1.png',
        linkLabel: "Plus d'informations",
        linkUrl: 'https://www.snacking.fr/concepts-124-TOUR-EGEE.php',
        pictogramUrl: '../../../../assets-proxy/animations/burger.svg',
        restaurantLibelle: 'Wonderfood',
        showPeriode: false,
      },
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: true,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/animations/animation1.png',
      title: "L'escale (Nutriscore OFF)",
      // surveyCampaign: {
      //   alreadyAnsweredToday: true,
      //   campaignId: 2,
      //   restaurantId: 2,
      //   surveyId: 2,
      // },
      type: RestaurantTypeValues.RestaurationRapide,
      description: BIG_DESCRIPTION,
      typeLabel: 'Restauration rapide',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 3,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(2, 30),
      hasFluidite: true,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept2.png',
      title: "R'Food",
      type: RestaurantTypeValues.ClickAndCollect,
      // surveyCampaign: {
      //   alreadyAnsweredToday: false,
      //   campaignId: 3,
      //   restaurantId: 3,
      //   surveyId: 3,
      // },
      typeLabel: 'Click & Collect',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 4,
      openedDays: weekDays,
      openedAt: getTodayWithHour(11, 0),
      closedAt: getTodayWithHour(14, 0),
      hasFluidite: true,
      hasMenu: true,
      imageUrl: '../../../../assets-proxy/concept3.png',
      title: 'Restaurant administratif de Périgueux',
      type: RestaurantTypeValues.Self,
      description:
        '<p class="xmsonormal" style="margin: 0cm 0cm 12.0pt 0cm;"><span style="font-size: 11.0pt; font-family: \'Calibri\',sans-serif; color: #201f1e;">Peu de temps pour d&eacute;jeuner&nbsp;? Envie de d&eacute;jeuner au bureau&nbsp;?</span></p>',
      typeLabel: 'Self',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 5,
      openedDays: [DayOfWeek.Monday, DayOfWeek.Tuesday],
      openedAt: getTodayWithHour(12, 0),
      closedAt: getTodayWithHour(14, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept4.png',
      title: 'La Cucina',
      type: RestaurantTypeValues.RestaurationRapide,
      typeLabel: 'Restauration flash',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 6,
      openedDays: [DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday],
      openedAt: getTodayWithHour(12, 0),
      closedAt: getTodayWithHour(20, 0),
      closedFrom: getDayFromTodayWithHour(0, 0, 0),
      closedTo: getDayFromTodayWithHour(10, 0, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept4.png',
      title: 'La Fermetura',
      type: RestaurantTypeValues.RestaurationRapide,
      typeLabel: 'Restauration flash',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 7,
      openedDays: [DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday],
      openedAt: getTodayWithHour(12, 0),
      closedAt: getTodayWithHour(20, 0),
      closedFrom: getDayFromTodayWithHour(3, 0, 0),
      closedTo: getDayFromTodayWithHour(3, 0, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept4.png',
      title: 'La Fermetura One day',
      type: RestaurantTypeValues.RestaurationRapide,
      typeLabel: 'Restauration flash',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 8,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant (embedded/bottom)',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'Concept Externe',
      allowOrder: true,
      allowOrderHistory: true,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 9,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant (embedded/top)',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'Concept Externe',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 10,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant (not embedded)',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'Concept Externe',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 11,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant (error)',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'Concept Externe',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: MOCK_SCORP_RESTAURANT_ID,
      openedDays: weekDays,
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept5.png',
      title: 'SCORP',
      type: RestaurantTypeValues.Scorp,
      sousType: RestaurantSousTypeValues.Scorp,
      typeLabel: 'Service de livraison - 7 jours / 7',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      description: 'toto',
      orderSettings: {
        availableServices: [RestaurantServiceValues.Lunch, RestaurantServiceValues.Dinner, RestaurantServiceValues.Night],
        cartMaxSingleItemAmount: 2,
        maxOrdersByDay: 2,
      },
      contact: {
        emails: ['toto@toto.fr', 'tata@tata.fr'],
        phone: '0612345678',
      },
      allowComments: true,
      isExternalCameraAllowed: false,
    },
    {
      id: MOCK_SCORP_ANTI_GASPI_RESTAURANT_ID,
      openedDays: weekDays,
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept5.png',
      title: 'SCORP Anti Gaspi',
      type: RestaurantTypeValues.Scorp,
      sousType: RestaurantSousTypeValues.AntiGaspi,
      openedAt: getTodayWithHour(10, 0),
      closedAt: getTodayWithHour(18, 0),
      typeLabel: 'Antiii gasspiiiiii',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      description: 'Gaspi toto',
      orderSettings: {
        availableServices: [],
        cartMaxSingleItemAmount: 2,
        maxOrdersByDay: 2,
      },
      contact: {
        emails: ['toto@toto.fr', 'tata@tata.fr'],
        phone: '0612345678',
      },
      allowComments: true,
      isExternalCameraAllowed: false,
    },
    {
      id: 14,
      openedDays: weekDays,
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept5.png',
      title: 'SAT EXTERNE',
      type: RestaurantTypeValues.RestaurantExterne,
      openedAt: getTodayWithHour(10, 0),
      closedAt: getTodayWithHour(18, 0),
      typeLabel: 'Ouverture avec QrCode',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: true,
      description: 'SAT EXTERNE avec ouverture QRCode',
      allowComments: false,
      isExternalCameraAllowed: false,
    },
  ],
};

const MOCK_GET_RESTAURANTS_MONO_OK: GetRestaurantsResult = {
  restaurants: [
    {
      id: 1,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: true,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept1.png',
      title: 'Wonderfood',
      type: RestaurantTypeValues.DinnerTakeaway,
      description:
        '<p class="xmsonormal" style="margin: 0cm 0cm 12.0pt 0cm;"><span style="font-size: 11.0pt; font-family: \'Calibri\',sans-serif; color: #201f1e;">Peu de temps pour d&eacute;jeuner&nbsp;? Envie de d&eacute;jeuner au bureau&nbsp;?</span></p>',
      typeLabel: 'Click & Collect',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
  ],
};

const MOCK_GET_RESTAURANTS_ONLY_ONE_WITH_ORDER_OK: GetRestaurantsResult = {
  restaurants: [
    {
      id: 8,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'External with order 1/1',
      allowOrder: true,
      allowOrderHistory: true,
      hasExternalOrderHistory: true,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
  ],
};

const MOCK_GET_RESTAURANTS_MULTI_BUT_ONLY_ONE_WITH_ORDER_OK: GetRestaurantsResult = {
  restaurants: [
    {
      id: 1,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: true,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/concept1.png',
      title: 'Wonderfood',
      type: RestaurantTypeValues.DinnerTakeaway,
      description:
        '<p class="xmsonormal" style="margin: 0cm 0cm 12.0pt 0cm;"><span style="font-size: 11.0pt; font-family: \'Calibri\',sans-serif; color: #201f1e;">Peu de temps pour d&eacute;jeuner&nbsp;? Envie de d&eacute;jeuner au bureau&nbsp;?</span></p>',
      typeLabel: 'Non external 1/2',
      allowOrder: false,
      allowOrderHistory: false,
      hasExternalOrderHistory: false,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
    {
      id: 8,
      openedDays: weekDays,
      openedAt: getTodayWithHour(1, 0),
      closedAt: getTodayWithHour(23, 0),
      hasFluidite: false,
      hasMenu: false,
      imageUrl: '../../../../assets-proxy/conceptExterne.png',
      title: 'Chaud Bouillant',
      type: RestaurantTypeValues.RestaurantExterne,
      typeLabel: 'External with order 2/2',
      allowOrder: true,
      allowOrderHistory: true,
      hasExternalOrderHistory: true,
      isExternalServiceATable: false,
      allowComments: false,
      isExternalCameraAllowed: false,
    },
  ],
};

function translateRestaurantsToEng(fr: GetRestaurantsResult): GetRestaurantsResult {
  return {
    ...fr,
    restaurants: [
      ...fr.restaurants.map((r) => ({
        ...r,
        animation: r.animation ? { ...r.animation, title: 'ENG:' + r.animation.title } : r.animation,
      })),
    ],
  };
}

export const MOCK_GET_RESTAURANTS = {
  OK_MULTI: MOCK_GET_RESTAURANTS_MULTI_OK,
  OK_MULTI_ENG: translateRestaurantsToEng(MOCK_GET_RESTAURANTS_MULTI_OK),
  OK_MONO: MOCK_GET_RESTAURANTS_MONO_OK,
  OK_ONLY_ONE_WITH_ORDER: MOCK_GET_RESTAURANTS_ONLY_ONE_WITH_ORDER_OK,
  OK_MULTI_BUT_ONLY_ONE_WITH_ORDER: MOCK_GET_RESTAURANTS_MULTI_BUT_ONLY_ONE_WITH_ORDER_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

const MOCK_GET_EXTERNAL_RESTAURANT_HOME_EMBEDDED_NAV_BOTTOM: GetExternalRestaurantHomeResult = {
  isEmbedded: true,
  navbarPosition: NavbarPosition.Bottom,
  url: 'https://cw.mypi.net/cw/30211/01A54FC5022E61B0',
};

const MOCK_GET_EXTERNAL_RESTAURANT_HOME_EMBEDDED_NAV_TOP: GetExternalRestaurantHomeResult = {
  isEmbedded: true,
  navbarPosition: NavbarPosition.Top,
  url: 'https://cw.mypi.net/cw/30211/01A54FC5022E61B0',
};

const MOCK_GET_EXTERNAL_RESTAURANT_HOME_NOT_EMBEDDED: GetExternalRestaurantHomeResult = {
  isEmbedded: false,
  navbarPosition: NavbarPosition.Bottom,
  url: 'https://cw.mypi.net/cw/30211/01A54FC5022E61B0',
};

const MOCK_GET_EXTERNAL_RESTAURANT_HOME_EXTERNAL_SAT: GetExternalRestaurantHomeResult = {
  isEmbedded: false,
  navbarPosition: NavbarPosition.Bottom,
  url: 'https://cw.mypi.net/cw/30211/01A54FC5022E61B0',
};

export const MOCK_GET_EXTERNAL_RESTAURANT_HOME = {
  EMBEDDED_NAV_BOTTOM: MOCK_GET_EXTERNAL_RESTAURANT_HOME_EMBEDDED_NAV_BOTTOM,
  EMBEDDED_NAV_TOP: MOCK_GET_EXTERNAL_RESTAURANT_HOME_EMBEDDED_NAV_TOP,
  NOT_EMBEDDED: MOCK_GET_EXTERNAL_RESTAURANT_HOME_NOT_EMBEDDED,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
  EXTERNAL_SAT: MOCK_GET_EXTERNAL_RESTAURANT_HOME_EXTERNAL_SAT,
};

export const MOCK_GET_CURRENT_FLUIDITE: Record<'OK_Faible' | 'OK_Moyen' | 'OK_Eleve', GetCurrentFluiditeResult> = {
  OK_Faible: { current: FluiditeTauxOccupationValues.Faible },
  OK_Moyen: { current: FluiditeTauxOccupationValues.Moyen },
  OK_Eleve: { current: FluiditeTauxOccupationValues.Eleve },
};

const EXTERNAL_REFS = {
  Entrees: 'HD',
  Plats: 'PP',
  Desserts: 'DE',
};

const getSimpleDish = (id: number, label: string, img: string): DishDto => ({
  id,
  label,
  allergens: [],
  isIncludedInMenu: false,
  thumbUrl: `../../../../assets-proxy/dishes/thumb/${img}`,
  mainImageUrl: `../../../../assets-proxy/dishes/${img}`,
  imageUrls: [`../../../../assets-proxy/dishes/${img}`],
  isPorkFree: true,
  hasPork: false,
  isVeggie: true,
  likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 10 },
  labels: [],
  markers: [],
  ingredients: [],
  nutritionnalValues: [],
  partners: [],
  formulesHelios: [],
  composantesMenuHelios: [],
  isPermanent: false,
});

const formula1: FormulaDto = {
  id: 1,
  label: 'Formule Démonstration',
  price: 3.29,
  description: 'Articles optionnels et obligatoires avec règles de nombres',
  imageUrl: '../../../../assets-proxy/formulas/formula1.jpg',
  thumbUrl: '../../../../assets-proxy/formulas/formula1.jpg',
  sections: [
    {
      id: 1,
      label: 'Section optionnelle, deux articles max',
      minQuantity: 1,
      maxQuantity: 2,
      isRequired: false,
      maxQuantitySameArticle: 1,
      dishes: [
        getSimpleDish(101, 'Pain sésame, salade, tomate séchée, mozzarella', 'dish3.jpg'),
        getSimpleDish(102, 'Pain baguette, jambon blanc, beurre', 'dish3.jpg'),
        getSimpleDish(103, 'Salade oeufs durs, crudités, croûtons', 'dish3.jpg'),
        getSimpleDish(104, 'Pâte, tomate séchée, mozzarella', 'dish3.jpg'),
      ],
    },
    {
      id: 2,
      label: 'Section obligatoire, un article max',
      minQuantity: 1,
      maxQuantity: 1,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [getSimpleDish(105, 'Brie', 'dish3.jpg'), getSimpleDish(106, 'Comte', 'dish3.jpg'), getSimpleDish(107, 'Camembert', 'dish3.jpg')],
    },
    {
      id: 3,
      label: 'Section obligatoire, un article min, deux articles max',
      minQuantity: 1,
      maxQuantity: 2,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [
        getSimpleDish(108, 'Yaourt nature', 'dish3.jpg'),
        getSimpleDish(109, 'Compote de fruits', 'dish3.jpg'),
        getSimpleDish(110, 'Beignet au chocolat', 'dish3.jpg'),
      ],
    },
    {
      id: 4,
      label: 'Section obligatoire, deux articles min, deux articles max',
      minQuantity: 2,
      maxQuantity: 2,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [getSimpleDish(111, 'Pomme Golden', 'dish3.jpg'), getSimpleDish(112, 'Abricot', 'dish3.jpg'), getSimpleDish(113, 'Kiwi jaune', 'dish3.jpg')],
    },
  ],
};

const formula2: FormulaDto = {
  id: 2,
  label: 'Formule Biopôle',
  price: 4.07,
  description: 'Sandwich ou salade, dessert et fruit de saison',
  imageUrl: '../../../../assets-proxy/formulas/formula2.webp',
  thumbUrl: '../../../../assets-proxy/formulas/formula2.webp',
  sections: [
    {
      id: 1,
      label: 'Salade ou Sandwich',
      minQuantity: 1,
      maxQuantity: 1,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [
        getSimpleDish(111, 'Pain sésame, mayonnaise, poulet, crudités', 'dish3.jpg'),
        getSimpleDish(112, 'Pain baguette, pesto de tomate, jambon sec, crudités, cantal', 'dish3.jpg'),
        getSimpleDish(113, 'Salade, jambon blanc, crudités, croûtons', 'dish3.jpg'),
        getSimpleDish(114, 'Salade, poulet, crudités, croûtons', 'dish3.jpg'),
      ],
    },
    {
      id: 2,
      label: 'Dessert',
      minQuantity: 1,
      maxQuantity: 1,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [
        getSimpleDish(115, 'Cookie', 'dish3.jpg'),
        getSimpleDish(116, 'Fromage blanc aux figues', 'dish3.jpg'),
        getSimpleDish(117, 'Brownie', 'dish3.jpg'),
      ],
    },
    {
      id: 3,
      label: 'Fruit de saison',
      minQuantity: 1,
      maxQuantity: 1,
      isRequired: true,
      maxQuantitySameArticle: 1,
      dishes: [getSimpleDish(108, 'Pomme Golden', 'dish3.jpg'), getSimpleDish(109, 'Abricot', 'dish3.jpg'), getSimpleDish(110, 'Kiwi jaune', 'dish3.jpg')],
    },
  ],
};

const MOCK_GET_RESTAURANT_MENU_OK_ANTI_GASPI = () => ({
  menus: [
    {
      date: getTodayWithHour(0, 0),
      orderLimitDate: addMinutes(new Date(), 60).toISOString(),
      isClosed: false,
      maxFormulasAllowed: 1,
      formulas: [],
      dishFamilies: [
        {
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Entrees,
          label: 'Entrées',
          maxItemsAllowed: null,
          dishes: [
            {
              allergens: [
                AllergenEnum.Milk,
                AllergenEnum.Crustaceans,
                AllergenEnum.Celery,
                AllergenEnum.Mustard,
                AllergenEnum.Sesame,
                AllergenEnum.Corn,
                AllergenEnum.Egg,
                AllergenEnum.Fish,
                AllergenEnum.Lupine,
                AllergenEnum.Molluscs,
                AllergenEnum.Peanuts,
                AllergenEnum.Nuts,
                AllergenEnum.Soy,
                AllergenEnum.Sulphites,
              ],
              description: 'Un plat + 2 composantes',
              isIncludedInMenu: false,
              label: 'Panier anti gaspi',
              quantiteLeftInStock: 2,
              price: 5,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: { amount: 100, percentageDailyIntake: 5 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: false, isLikedByUser: false, totalLikes: 10 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
  ],
});

const MOCK_GET_RESTAURANT_MENU_OK = (isScorp: boolean, withFormulas: boolean): GetRestaurantMenusResult => ({
  menus: [
    {
      date: getTodayWithHour(0, 0),
      orderLimitDate: isScorp ? addMinutes(new Date(), 60).toISOString() : undefined,
      isClosed: false,
      maxFormulasAllowed: 1,
      formulas: withFormulas ? [formula1, formula2] : [],
      dishFamilies: [
        {
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Entrees,
          label: 'Entrées',
          maxItemsAllowed: 1,
          dishes: [
            {
              allergens: [
                AllergenEnum.Milk,
                AllergenEnum.Crustaceans,
                AllergenEnum.Celery,
                AllergenEnum.Mustard,
                AllergenEnum.Sesame,
                AllergenEnum.Corn,
                AllergenEnum.Egg,
                AllergenEnum.Fish,
                AllergenEnum.Lupine,
                AllergenEnum.Molluscs,
                AllergenEnum.Peanuts,
                AllergenEnum.Nuts,
                AllergenEnum.Soy,
                AllergenEnum.Sulphites,
              ],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Concombre en gaspacho',
              price: 1.78,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: { amount: 100, percentageDailyIntake: 5 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 10 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Carottes à la coriandre, chantilly au cumin',
              price: 2.1,
              imageUrls: [],
              id: 2,
              nutriscore: 'A',
              calories: { amount: 92, percentageDailyIntake: 4 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: true,
            },
          ],
        },
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          maxItemsAllowed: 2,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 3,
              nutriscore: 'C',
              calories: { amount: 693, percentageDailyIntake: 34 },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { isLikedByUser: true, totalLikes: 10, canBeNotified: false },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: ['Plats chauds'],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 4,
              carbonScore: undefined,
              greenScore: undefined,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 0 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: ['Plats chauds'],
              isPermanent: false,
            },
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Légumes grillés, feta AOP et basilic',
              price: 4.45,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish5.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish5.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish5.jpg'],
              id: 5,
              nutriscore: 'B',
              calories: { amount: 510, percentageDailyIntake: 25 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: ['Sandwichs'],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Corn, AllergenEnum.Lupine],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Boeuf bourguignon',
              price: 6.21,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish8.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish8.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish8.jpg', '../../../../assets-proxy/dishes/dish8-bis.jpg'],
              id: 6,
              carbonScore: 'D',
              greenScore: 'A+',
              nutriscore: 'C',
              calories: { amount: 510, percentageDailyIntake: 31 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: false,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [
                {
                  code: 'GAS',
                  imageUrl: '../../../../assets-proxy/antigaspiMarker.png',
                  sigle: '',
                  label: 'Anti-Gaspi',
                  description:
                    'Recette valorisant un produit en limitant au maximum la perte ou le gaspillage de ce dernier.<br/> Réduire notre empreinte sur l’environnement est au menu dans nos cuisines.',
                },
              ],
              ingredients: ['Bourguignon de boeuf AOP', 'Oignons jeunes', 'Vin rouge', 'Lardons', 'Carottes'],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [
                {
                  code: 'GAS',
                  imageUrl: '../../../../assets-proxy/challongePartner.png',
                  sigle: '',
                  label: 'Ferme de challonge',
                  description: 'Ferme de challonge',
                },
              ],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          maxItemsAllowed: 1,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 7,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 8,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(1, 0, 0),
      isClosed: false,
      maxFormulasAllowed: 1,
      formulas: withFormulas ? [formula1, formula2] : [],
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(2, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: { amount: 693, percentageDailyIntake: 34 },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(3, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Entrées',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Entrees,
          dishes: [
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Concombre en gaspacho',
              price: 1.78,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: { amount: 100, percentageDailyIntake: 5 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Carottes à la coriandre, chantilly au cumin',
              price: 2.1,
              mainImageUrl: '../../../../assets-proxy/dishes/dish2.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish2.jpg'],
              id: 2,
              nutriscore: 'A',
              calories: { amount: 92, percentageDailyIntake: 4 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: { amount: 693, percentageDailyIntake: 34 },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Légumes grillés, feta AOP et basilic',
              price: 4.45,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish5.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish5.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish5.jpg'],
              id: 3,
              nutriscore: 'B',
              calories: { amount: 510, percentageDailyIntake: 25 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Boeuf bourguignon',
              price: 6.21,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish8.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish8.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish8.jpg'],
              id: 4,
              nutriscore: 'C',
              calories: { amount: 510, percentageDailyIntake: 31 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: false,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description: 'Viande Bovine Française D',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(4, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Entrées',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Entrees,
          dishes: [
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Concombre en gaspacho',
              price: 1.78,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: { amount: 100, percentageDailyIntake: 5 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Carottes à la coriandre, chantilly au cumin',
              price: 2.1,
              mainImageUrl: '../../../../assets-proxy/dishes/dish2.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish2.jpg'],
              id: 2,
              nutriscore: 'A',
              calories: { amount: 92, percentageDailyIntake: 4 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: { amount: 693, percentageDailyIntake: 34 },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Légumes grillés, feta AOP et basilic',
              price: 4.45,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish5.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish5.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish5.jpg'],
              id: 3,
              nutriscore: 'B',
              calories: { amount: 510, percentageDailyIntake: 25 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Boeuf bourguignon',
              price: 6.21,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish8.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish8.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish8.jpg'],
              id: 4,
              nutriscore: 'C',
              calories: { amount: 510, percentageDailyIntake: 31 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: false,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 1',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 2',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 3',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 4',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 5',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: { amount: 189, percentageDailyIntake: 9 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: { amount: 250, percentageDailyIntake: 12 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(5, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(6, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(9, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: { amount: 460, percentageDailyIntake: 23 },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                { type: NutritionnalValueTypeEnum.Sugar, value: 4, unit: NutritionnalValueUnitEnum.Gram, order: 3 },
                { type: NutritionnalValueTypeEnum.Lipids, value: 15, unit: NutritionnalValueUnitEnum.Gram, order: 4 },
                { type: NutritionnalValueTypeEnum.SaturatedFattyAcids, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 5 },
                { type: NutritionnalValueTypeEnum.Fibers, value: 10, unit: NutritionnalValueUnitEnum.Gram, order: 6 },
                { type: NutritionnalValueTypeEnum.Protein, value: 26, unit: NutritionnalValueUnitEnum.Gram, order: 1 },
                { type: NutritionnalValueTypeEnum.Carbohydrates, value: 20, unit: NutritionnalValueUnitEnum.Gram, order: 2 },
                { type: NutritionnalValueTypeEnum.Salt, value: 0.5, unit: NutritionnalValueUnitEnum.Gram, order: 7 },
                { type: NutritionnalValueTypeEnum.Iron, value: 125, unit: NutritionnalValueUnitEnum.Milligram, order: 8 },
                { type: NutritionnalValueTypeEnum.Calcium, value: 230, unit: NutritionnalValueUnitEnum.Milligram, order: 9 },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
  ],
});

const MOCK_GET_RESTAURANT_MENU_OK_ALL_CLOSED: GetRestaurantMenusResult = {
  menus: [
    {
      date: getTodayWithHour(0, 0),
      isClosed: true,
      dishFamilies: [],
    },
    {
      date: getDayFromTodayWithHour(1, 0, 0),
      isClosed: true,
      dishFamilies: [],
    },
    {
      date: getDayFromTodayWithHour(2, 0, 0),
      isClosed: true,
      dishFamilies: [],
    },
    {
      date: getDayFromTodayWithHour(3, 0, 0),
      isClosed: true,
      dishFamilies: [],
    },
    {
      date: getDayFromTodayWithHour(4, 0, 0),
      isClosed: true,
      dishFamilies: [],
    },
  ],
};

const MOCK_GET_RESTAURANT_MENU_OK_WITH_CLOSURE: GetRestaurantMenusResult = {
  menus: [
    {
      date: getTodayWithHour(0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Entrées',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Entrees,
          dishes: [
            {
              allergens: [
                AllergenEnum.Milk,
                AllergenEnum.Crustaceans,
                AllergenEnum.Celery,
                AllergenEnum.Mustard,
                AllergenEnum.Sesame,
                AllergenEnum.Corn,
                AllergenEnum.Egg,
                AllergenEnum.Fish,
                AllergenEnum.Lupine,
                AllergenEnum.Molluscs,
                AllergenEnum.Peanuts,
                AllergenEnum.Nuts,
                AllergenEnum.Soy,
                AllergenEnum.Sulphites,
              ],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Concombre en gaspacho',
              price: 1.78,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: {
                amount: 100,
                percentageDailyIntake: 5,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Carottes à la coriandre, chantilly au cumin',
              price: 2.1,
              imageUrls: [],
              id: 2,
              nutriscore: 'A',
              calories: {
                amount: 92,
                percentageDailyIntake: 4,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: {
                amount: 693,
                percentageDailyIntake: 34,
              },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: {
                amount: 460,
                percentageDailyIntake: 23,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Légumes grillés, feta AOP et basilic',
              price: 4.45,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish5.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish5.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish5.jpg'],
              id: 3,
              nutriscore: 'B',
              calories: {
                amount: 510,
                percentageDailyIntake: 25,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Corn, AllergenEnum.Lupine],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Boeuf bourguignon',
              price: 6.21,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish8.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish8.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish8.jpg', '../../../../assets-proxy/dishes/dish8-bis.jpg'],
              id: 4,
              nutriscore: 'C',
              calories: {
                amount: 510,
                percentageDailyIntake: 31,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: false,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [
                {
                  code: 'GAS',
                  imageUrl: '../../../../assets-proxy/antigaspiMarker.png',
                  sigle: '',
                  label: 'Anti-Gaspi',
                  description:
                    'Recette valorisant un produit en limitant au maximum la perte ou le gaspillage de ce dernier.<br/> Réduire notre empreinte sur l’environnement est au menu dans nos cuisines.',
                },
              ],
              ingredients: ['Bourguignon de boeuf AOP', 'Oignons jeunes', 'Vin rouge', 'Lardons', 'Carottes'],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [
                {
                  code: 'GAS',
                  imageUrl: '../../../../assets-proxy/challongePartner.png',
                  sigle: '',
                  label: 'Ferme de challonge',
                  description: 'Ferme de challonge',
                },
              ],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 12,
              },

              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(1, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: {
                amount: 460,
                percentageDailyIntake: 23,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(2, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: {
                amount: 693,
                percentageDailyIntake: 34,
              },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: {
                amount: 460,
                percentageDailyIntake: 23,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
    {
      date: getDayFromTodayWithHour(3, 0, 0),
      isClosed: true,
      dishFamilies: [],
    },
    {
      date: getDayFromTodayWithHour(4, 0, 0),
      isClosed: false,
      dishFamilies: [
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Concombre en gaspacho',
              price: 1.78,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish1.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish1.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish1.jpg'],
              id: 1,
              nutriscore: 'A',
              calories: {
                amount: 100,
                percentageDailyIntake: 5,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Carottes à la coriandre, chantilly au cumin',
              price: 2.1,
              mainImageUrl: '../../../../assets-proxy/dishes/dish2.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish2.jpg'],
              id: 2,
              nutriscore: 'A',
              calories: {
                amount: 92,
                percentageDailyIntake: 4,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              standName: 'Wonderfood',
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Plats',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Plats,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'L’authentique burger veggie du Chef',
              price: 5.64,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish3.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish3.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish3.jpg'],
              id: 1,
              nutriscore: 'C',
              calories: {
                amount: 693,
                percentageDailyIntake: 34,
              },
              isPorkFree: false,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Petit farcis au caviar d’aubergine',
              price: 4.31,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish4.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish4.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish4.jpg'],
              id: 2,
              nutriscore: 'B',
              calories: {
                amount: 460,
                percentageDailyIntake: 23,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Légumes grillés, feta AOP et basilic',
              price: 4.45,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish5.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish5.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish5.jpg'],
              id: 3,
              nutriscore: 'B',
              calories: {
                amount: 510,
                percentageDailyIntake: 25,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk, AllergenEnum.Crustaceans],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Boeuf bourguignon',
              price: 6.21,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish8.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish8.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish8.jpg'],
              id: 4,
              nutriscore: 'C',
              calories: {
                amount: 510,
                percentageDailyIntake: 31,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: false,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 1',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 2',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 3',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 4',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
        {
          label: 'Desserts 5',
          isIncludedInMenu: false,
          externalRef: EXTERNAL_REFS.Desserts,
          dishes: [
            {
              allergens: [],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Mousse au chocolat',
              price: 2.25,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish6.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish6.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish6.jpg'],
              id: 1,
              nutriscore: 'E',
              calories: {
                amount: 189,
                percentageDailyIntake: 9,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
            {
              allergens: [AllergenEnum.Milk],
              description: 'Descr',
              isIncludedInMenu: false,
              label: 'Triple caramel chocolat salé',
              price: 1.52,
              thumbUrl: '../../../../assets-proxy/dishes/thumb/dish7.png',
              mainImageUrl: '../../../../assets-proxy/dishes/dish7.jpg',
              imageUrls: ['../../../../assets-proxy/dishes/dish7.jpg'],
              id: 2,
              nutriscore: 'E',
              calories: {
                amount: 250,
                percentageDailyIntake: 12,
              },
              isPorkFree: true,
              hasPork: false,
              isVeggie: true,
              likes: { canBeNotified: true, isLikedByUser: false, totalLikes: 3 },
              labels: [
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/aopLabel.png',
                  sigle: 'VBF',
                  label: 'Viande Bovine Française',
                  description:
                    'Ce label assure au consommateur que la viande de boeuf est issue d’animaux nés, élevés, abattus, découpés et transformés en France. Il garantit également un mode de production respectueux de l’environnement, du bien-être animal et d’animaux nourris grâce à une alimentation saine et durable.',
                },
                {
                  code: 'O',
                  imageUrl: '../../../../assets-proxy/labelRouge.png',
                  sigle: 'VBF',
                  label: 'Label Rouge',
                  description:
                    'Label Rouge, c’est le signe de qualité supérieure d’un produit par rapport à un produit courant similaire. Cette qualité supérieure est garantie par les exigences définies dans les cahiers des charges, et est vérifiée régulièrement par des tests sensoriels réalisés auprès de panels de consommateurs et/ou de jurys d’experts.',
                },
              ],
              markers: [],
              ingredients: [],
              nutritionnalValues: [
                {
                  type: NutritionnalValueTypeEnum.Sugar,
                  value: 4,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 3,
                },
                {
                  type: NutritionnalValueTypeEnum.Lipids,
                  value: 15,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 4,
                },
                {
                  type: NutritionnalValueTypeEnum.SaturatedFattyAcids,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 5,
                },
                {
                  type: NutritionnalValueTypeEnum.Fibers,
                  value: 10,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 6,
                },
                {
                  type: NutritionnalValueTypeEnum.Protein,
                  value: 26,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 1,
                },
                {
                  type: NutritionnalValueTypeEnum.Carbohydrates,
                  value: 20,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 2,
                },
                {
                  type: NutritionnalValueTypeEnum.Salt,
                  value: 0.5,
                  unit: NutritionnalValueUnitEnum.Gram,
                  order: 7,
                },
                {
                  type: NutritionnalValueTypeEnum.Iron,
                  value: 125,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 8,
                },
                {
                  type: NutritionnalValueTypeEnum.Calcium,
                  value: 230,
                  unit: NutritionnalValueUnitEnum.Milligram,
                  order: 9,
                },
              ],
              partners: [],
              formulesHelios: [],
              composantesMenuHelios: [],
              isPermanent: false,
            },
          ],
        },
      ],
    },
  ],
};

const MOCK_GET_RESTAURANT_MENU_EMPTY: GetRestaurantMenusResult = {
  menus: [],
};

const removeNutriscores = (res: GetRestaurantMenusResult): GetRestaurantMenusResult => {
  return {
    menus: [...res.menus].map((x) => ({
      ...x,
      dishFamilies: x.dishFamilies.map((f) => ({ ...f, dishes: f.dishes.map((d) => ({ ...d, nutriscore: undefined })) })),
    })),
  };
};

export const MOCK_GET_RESTAURANT_MENU = {
  OK: (isScorp: boolean, withFormulas: boolean) => MOCK_GET_RESTAURANT_MENU_OK(isScorp, withFormulas),
  OK_ANTIGASPI: () => MOCK_GET_RESTAURANT_MENU_OK_ANTI_GASPI(),
  OK_WITHOUT_NUTRISCORE: removeNutriscores(MOCK_GET_RESTAURANT_MENU_OK(false, false)),
  OK_ALL_CLOSED: MOCK_GET_RESTAURANT_MENU_OK_ALL_CLOSED,
  OK_WITH_CLOSURE: MOCK_GET_RESTAURANT_MENU_OK_WITH_CLOSURE,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
  EMPTY: MOCK_GET_RESTAURANT_MENU_EMPTY,
};

const MOCK_GET_RESTAURANT_FLUIDITE_OK_WITH_CURRENT_HIGHER: GetFluiditeRatesResult = {
  rates: [
    { lastWeekRate: 2, currentWeekRate: 0, startsAt: '2022-06-30T10:00:00Z', endsAt: '2022-06-30T10:10:00Z' },
    { lastWeekRate: 3, currentWeekRate: 2, startsAt: '2022-06-30T10:10:00Z', endsAt: '2022-06-30T10:20:00Z' },
    { lastWeekRate: 10, currentWeekRate: 15, startsAt: '2022-06-30T10:20:00Z', endsAt: '2022-06-30T10:30:00Z' },
    { lastWeekRate: 15, currentWeekRate: 14, startsAt: '2022-06-30T10:30:00Z', endsAt: '2022-06-10:40:00Z' },
    { lastWeekRate: 20, currentWeekRate: 36, startsAt: '2022-06-30T10:40:00Z', endsAt: '2022-06-10:50:00Z' },
    { lastWeekRate: 25, currentWeekRate: 53, startsAt: '2022-06-30T10:50:00Z', endsAt: '2022-06-11:00:00Z' },
    { lastWeekRate: 60, currentWeekRate: 100, currentRate: 85, startsAt: '2022-06-30T11:00:00Z', endsAt: '2022-06-30T11:10:00Z' },
    { lastWeekRate: 86, startsAt: '2022-06-30T11:10:00Z', endsAt: '2022-06-30T11:20:00Z' },
    { lastWeekRate: 55, startsAt: '2022-06-30T11:20:00Z', endsAt: '2022-06-30T11:30:00Z' },
    { lastWeekRate: 50, startsAt: '2022-06-30T11:30:00Z', endsAt: '2022-06-30T11:40:00Z' },
    { lastWeekRate: 83, startsAt: '2022-06-30T11:40:00Z', endsAt: '2022-06-11:50:00Z' },
    { lastWeekRate: 83, startsAt: '2022-06-30T11:50:00Z', endsAt: '2022-06-12:00:00Z' },
    { lastWeekRate: 60, startsAt: '2022-06-30T12:00:00Z', endsAt: '2022-06-30T12:10:00Z' },
    { lastWeekRate: 40, startsAt: '2022-06-30T12:10:00Z', endsAt: '2022-06-30T12:20:00Z' },
    { lastWeekRate: 40, startsAt: '2022-06-30T12:20:00Z', endsAt: '2022-06-30T12:30:00Z' },
    { lastWeekRate: 25, startsAt: '2022-06-30T12:30:00Z', endsAt: '2022-06-30T12:40:00Z' },
    { lastWeekRate: 25, startsAt: '2022-06-30T12:40:00Z', endsAt: '2022-06-30T12:50:00Z' },
    { lastWeekRate: 20, startsAt: '2022-06-30T12:50:00Z', endsAt: '2022-06-30T13:00:00Z' },
  ],
  capacity: 250,
  // remainingSeats: 50,
};

const MOCK_GET_RESTAURANT_FLUIDITE_KO_CLOSED_LAST_WEEK: GetFluiditeRatesResult = {
  rates: [
    { lastWeekRate: 0, startsAt: '2022-06-30T10:00:00Z', endsAt: '2022-06-30T10:15:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T10:15:00Z', endsAt: '2022-06-30T10:30:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T10:30:00Z', endsAt: '2022-06-30T10:45:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T10:45:00Z', endsAt: '2022-06-30T11:00:00Z' },
    { lastWeekRate: 0, currentRate: undefined, startsAt: '2022-06-30T11:00:00Z', endsAt: '2022-06-30T11:15:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T11:15:00Z', endsAt: '2022-06-30T11:30:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T11:30:00Z', endsAt: '2022-06-30T11:45:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T11:45:00Z', endsAt: '2022-06-30T12:00:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T12:00:00Z', endsAt: '2022-06-30T12:15:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T12:15:00Z', endsAt: '2022-06-30T12:30:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T12:30:00Z', endsAt: '2022-06-30T12:45:00Z' },
    { lastWeekRate: 0, startsAt: '2022-06-30T12:45:00Z', endsAt: '2022-06-30T13:00:00Z' },
  ],
  capacity: 250,
};

const MOCK_GET_RESTAURANT_FLUIDITE_OK_WITH_CURRENT_LOWER: GetFluiditeRatesResult = {
  rates: [
    { lastWeekRate: 0, currentWeekRate: 0, startsAt: '2022-06-30T10:00:00Z', endsAt: '2022-06-30T10:10:00Z' },
    { lastWeekRate: 0, currentWeekRate: 0, startsAt: '2022-06-30T10:10:00Z', endsAt: '2022-06-30T10:20:00Z' },
    { lastWeekRate: 2, currentWeekRate: 4, startsAt: '2022-06-30T10:20:00Z', endsAt: '2022-06-30T10:30:00Z' },
    { lastWeekRate: 7, currentWeekRate: 8, startsAt: '2022-06-30T10:30:00Z', endsAt: '2022-06-10:40:00Z' },
    { lastWeekRate: 7, currentWeekRate: 15, startsAt: '2022-06-30T10:40:00Z', endsAt: '2022-06-10:50:00Z' },
    { lastWeekRate: 7, currentWeekRate: 45, startsAt: '2022-06-30T10:50:00Z', endsAt: '2022-06-11:00:00Z' },
    { lastWeekRate: 74, currentWeekRate: 100, currentRate: 60, startsAt: '2022-06-30T11:00:00Z', endsAt: '2022-06-30T11:10:00Z' },
    { lastWeekRate: 85, startsAt: '2022-06-30T11:10:00Z', endsAt: '2022-06-30T11:20:00Z' },
    { lastWeekRate: 72, startsAt: '2022-06-30T11:20:00Z', endsAt: '2022-06-30T11:30:00Z' },
    { lastWeekRate: 62, startsAt: '2022-06-30T11:30:00Z', endsAt: '2022-06-30T11:40:00Z' },
    { lastWeekRate: 30, startsAt: '2022-06-30T11:40:00Z', endsAt: '2022-06-30T11:50:00Z' },
    { lastWeekRate: 20, startsAt: '2022-06-30T11:50:00Z', endsAt: '2022-06-30T12:00:00Z' },
  ],
  capacity: 250,
  remainingSeats: 225,
};

export const MOCK_GET_RESTAURANT_FLUIDITE = {
  OK_WITH_CURRENT_HIGHER: MOCK_GET_RESTAURANT_FLUIDITE_OK_WITH_CURRENT_HIGHER,
  OK_WITH_CURRENT_LOWER: MOCK_GET_RESTAURANT_FLUIDITE_OK_WITH_CURRENT_LOWER,
  KO_RESTAURANT_CLOSED_LAST_WEEK: MOCK_GET_RESTAURANT_FLUIDITE_KO_CLOSED_LAST_WEEK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
